import React, { createContext, useContext, useState } from "react";

const MyContext = createContext();


export const MyContextProvider = ({ children }) => {

   const [showContactModal, setShowContactModal] = useState(false);

    const openModal = () => {
       
        setShowContactModal(true);
    };

    const closeModal = () => setShowContactModal(false);

  
  const [newCustomAttributeDetails, setNewCustomAttributeDetails] = useState({
    name: "",
    key: "",
    format: "",
  });

// const baseUrl= 'https://payin.shreedevs.com'; 
// const baseUrl =
// process.env.NODE_ENV === "development"
//   ? "https://uat.anlook.com" 
//   : "https://api.anlook.com"; 

     const baseUrl =
    process.env.NODE_ENV === "development"
      ? "https://api.anlook.com"
         : "https://api.anlook.com"; 

const baseUrl2= 'https://openApi.anlook.com'; 
const config= {
  headers: {
    "Content-Type": "application/json",
    Authorization: "Basic YW5sb29rQGdtYWlsLmNvbTpBbmxvb2tAMTIzNDU=",
  },
};
const config2= {
  headers: {
    "Content-Type": "application/json",
    Authorization: "Basic YW5sb29rQGdtYWlsLmNvbTpBbmxvb2tAMTIzNDU=",
    "Client-Id" :"Message Notifier",
  },
};

  return (
    <MyContext.Provider
      value={{
        setNewCustomAttributeDetails,
        newCustomAttributeDetails,
        baseUrl,
        baseUrl2,
        config,
        config2,
        showContactModal, openModal, closeModal 
      }}
    >
      {children}
    </MyContext.Provider>
  );
};


export const useModal = () => {
  const context = useContext(MyContext);
  if (!context) {
    throw new Error("useModal must be used inside MyContextProvider");
  }
  return context;
};



export default MyContext;
